<div class="l-top-navi">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <div class="l-top-navi__back-area">
          <a
            id="checkin-standby-flight-availability-sub-header-back"
            class="l-top-navi__back-link"
            href="javascript:void(0)"
            (click)="onClickBackButton($event)"
          >
            <span
              class="u-visually-hidden"
              innerHTML="{{ 'm_static_message-reader.goBackToPreviousPage' | staticMsg }}"
            ></span
          ></a>
        </div>
        <div class="l-top-navi__heading-area">
          <h1
            class="l-top-navi__heading-text"
            innerHTML="{{ 'm_static_message-heading.standbyAvailability' | staticMsg }}"
          ></h1>
        </div>
        <div class="l-top-navi__function-area"></div>

        <!-- [ステップナビゲーション] -->
        <div class="l-top-navi__progress-area">
          <ol class="l-top-navi__progress-list">
            <li class="l-top-navi__progress-item l-top-navi__progress-item--active l-top-navi__progress-item--current">
              <div class="l-top-navi__progress-wrap">
                <span
                  *aswIfScreenSize="'PC'"
                  class="u-visually-hidden"
                  [innerHTML]="'reader.breadcrumb.current' | staticMsg"
                ></span>
                <span
                  *aswIfScreenSize="['SP', 'TAB']"
                  class="u-visually-hidden"
                  [innerHTML]="'alt.stepBar' | staticMsg : { '0': this.stepNum, '1': this.currentStepNum }"
                ></span>
                <span
                  class="l-top-navi__progress-num"
                  innerHTML="{{ 'm_static_message-label.breadcrumb.first' | staticMsg }}"
                ></span>
                <span
                  class="l-top-navi__progress-text"
                  innerHTML="{{ 'm_static_message-label.breadcrumbSearch' | staticMsg }}"
                ></span>
              </div>
            </li>
            <li class="l-top-navi__progress-item">
              <em class="l-top-navi__progress-wrap">
                <span
                  class="l-top-navi__progress-num"
                  innerHTML="{{ 'm_static_message-label.breadcrumb.second' | staticMsg }}"
                ></span>
                <span
                  class="l-top-navi__progress-text"
                  innerHTML="{{ 'm_static_message-label.breadcrumbReview' | staticMsg }}"
                ></span>
              </em>
            </li>
            <li class="l-top-navi__progress-item">
              <div class="l-top-navi__progress-wrap">
                <span
                  class="l-top-navi__progress-num"
                  innerHTML="{{ 'm_static_message-label.breadcrumb.third' | staticMsg }}"
                ></span>
                <span
                  class="l-top-navi__progress-text"
                  innerHTML="{{ 'm_static_message-label.breadcrumbComplete' | staticMsg }}"
                ></span>
              </div>
            </li>
          </ol>
        </div>
        <!-- //[ステップナビゲーション] -->
      </div>
    </div>
  </div>
</div>
